import CompareCardSmartsRecommendations from './CompareCardSmartsRecommendations';
import CompareCardCustomRecommendations from './CompareCardCustomRecommendations';

export {
	CompareCardSmartsRecommendations,
	CompareCardCustomRecommendations
};


// WEBPACK FOOTER //
// ./src/js/features/compare/recommendations/index.js